import fetchProducts from "./fetchProducts";
import { UploadFileParams, IUploadFileResponse } from "../types";
import { findNumberOfInvalidProducts } from "../utils/productUtils";
import { AlertType } from "../../../interfaces/enums";

const uploadFile = async ({
  csvEachLineArray,
  setIsLoading,
  setToast,
  setProgressBarLevel,
}: UploadFileParams): Promise<IUploadFileResponse> => {
  setIsLoading(true);

  try {
    const response = await fetchProducts(csvEachLineArray, setProgressBarLevel);

    // clean the progress bar level
    setProgressBarLevel?.({
      level: 0,
      totalItems: 0,
    });

    if (response.status === 200) {
      const newFetchedProducts = response.fetchedProducts ?? [];

      // checking invalid products
      const numInvalidProducts = findNumberOfInvalidProducts(newFetchedProducts);
      if (numInvalidProducts > 0) {
        setToast({
          type: AlertType.Error,
          message: `${numInvalidProducts} ${
            numInvalidProducts > 1 ? "products" : "product"
          } could not be loaded. Please reload those items or remove them from the list.`,
        });
      }

      const newFetchedProductsWithCsvLineArray = newFetchedProducts.map((product) => ({
        ...product,
        csvLineArray: csvEachLineArray[parseInt(product.index)],
      }));

      return { newFetchedProducts: newFetchedProductsWithCsvLineArray };
    }

    // failed case
    setToast({
      type: AlertType.Error,
      message: response.message,
    });
    return { newFetchedProducts: [] };
  } catch (error) {
    setToast({
      type: AlertType.Error,
      message: "An error occurred while uploading the file",
    });
    return { newFetchedProducts: [] };
  } finally {
    setIsLoading(false);
  }
};

export default uploadFile;
